import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthService } from './auth.service';

/**
 * Allows navigation only for authenticated users. Waits for Firebase to report
 * the initial auth state, then redirects to `/login` when signed out.
 */
export const authGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.ready;

  return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};
